<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="add" icon="el-icon-plus">添加</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh" @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "ContractMakeup",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'compensation',
      breadcrumb: [
        { name: "合同管理" },
        { name: "合同补差" },
      ],
      formInline: {
        con_num: "", //合同编号
        shname: "", //客户名称
      },
      formCtrl: [
        {
          label: "合同编号",
          keyName: "con_num",
          placeholder: "请填写合同编号",
          type: "text",
        },
        {
          label: "客户名称",
          keyName: "shname",
          placeholder: "请填写客户名称",
          type: "text",
        },
      ],
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "endtime", label: "合同截止日期", minwidth: 120 },
        { keyName: "money", label: "补差金额", align:'right', className:'pr30', minwidth: 120},
        { keyName: "edittime", label: "补差时间", minwidth: 120 },
        { keyName: "content", label: "备注信息", minwidth: 150 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/makeupedit?id=${id}&mode=edit`
            );
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
    }
  },
  methods: {
    add() {
      this.$router.push(
        `/contract/makeupdetail?mode=add`
      );
    },
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>